"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readXingHeader = exports.XingHeaderFlags = exports.LameEncoderVersion = exports.InfoTagHeaderTag = void 0;
const Token = require("token-types");
const util = require("../common/Util");
const ExtendedLameHeader_1 = require("./ExtendedLameHeader");
exports.InfoTagHeaderTag = new Token.StringType(4, 'ascii');
exports.LameEncoderVersion = new Token.StringType(6, 'ascii');
exports.XingHeaderFlags = {
    len: 4,
    get: (buf, off) => {
        return {
            frames: util.isBitSet(buf, off, 31),
            bytes: util.isBitSet(buf, off, 30),
            toc: util.isBitSet(buf, off, 29),
            vbrScale: util.isBitSet(buf, off, 28)
        };
    }
};
function readXingHeader(tokenizer) {
    return __awaiter(this, void 0, void 0, function* () {
        const flags = yield tokenizer.readToken(exports.XingHeaderFlags);
        const xingInfoTag = {};
        if (flags.frames) {
            xingInfoTag.numFrames = yield tokenizer.readToken(Token.UINT32_BE);
        }
        if (flags.bytes) {
            xingInfoTag.streamSize = yield tokenizer.readToken(Token.UINT32_BE);
        }
        if (flags.toc) {
            xingInfoTag.toc = Buffer.alloc(100);
            yield tokenizer.readBuffer(xingInfoTag.toc);
        }
        if (flags.vbrScale) {
            xingInfoTag.vbrScale = yield tokenizer.readToken(Token.UINT32_BE);
        }
        const lameTag = yield tokenizer.peekToken(new Token.StringType(4, 'ascii'));
        if (lameTag === 'LAME') {
            yield tokenizer.ignore(4);
            xingInfoTag.lame = {
                version: yield tokenizer.readToken(new Token.StringType(5, 'ascii'))
            };
            const match = xingInfoTag.lame.version.match(/\d+.\d+/g);
            if (match) {
                const majorMinorVersion = xingInfoTag.lame.version.match(/\d+.\d+/g)[0];
                const version = majorMinorVersion.split('.').map(n => parseInt(n, 10));
                if (version[0] >= 3 && version[1] >= 90) {
                    xingInfoTag.lame.extended = yield tokenizer.readToken(ExtendedLameHeader_1.ExtendedLameHeader);
                }
            }
        }
        return xingInfoTag;
    });
}
exports.readXingHeader = readXingHeader;
